import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import SelectField from "../../library/components/Select";
import ActionModal from "../../ui/modal/ActionModal";
import logo from '../../images/image_3.png'
import logoutIcon from '../../dashboardicon/logout.svg'
import { useLogoutMutation } from "../../services/loginservices";
import './navigation.css'
import {  parseJwt } from "../utilities/utils";
import { setCookie } from "../utilities/cookieUtils";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { Power,HouseDoor } from "react-bootstrap-icons";
import {  Divider,
} from "@mui/material";
import axios from "axios";
import { BASE_URLS } from "../../constants/constants";
// import "./ElectionHeader.css";

function Navigation(props) {
  const[logoutApi]= useLogoutMutation()
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const userData =localStorage?.access_token && parseJwt(localStorage?.access_token);
  const userId = localStorage.access_token && parseJwt(localStorage.access_token)?.preferred_username
  const user = userData?.name
  const [stateValue, setStateValue] = useState({})

   useEffect(() => {
    if (stateValue.photoUrl) {
      axios
        .get(BASE_URLS.OBJECTSTORE_BASE_URL+"api/v1/document/getFile?bucketName=objectstorage&fileName="+ stateValue.photoUrl, {
           headers:{ 'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0]||"master",
          'appName':"SVP2.0"
          }
        })
        .then((res) => {
          let data = res?.data;
          setStateValue((prevState) => ({ ...prevState,...data }));
          // setStateValue((prev)=>({...prev, ...data}))
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [stateValue.photoUrl]);


    useEffect(() => {
    if (userId ) {
      axios
        .get(BASE_URLS.COMMON_SERVICES_BASE_URL+"api/v1/user-management/user/get/UpdateProfileDetails/" + userId, {
          headers:{ 'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0]||"master"}
          })
        .then((res) => {
          let data = res?.data
          setStateValue((prev) => ({ ...prev, ...data }))
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [])


  function handleClose() {
    setShow(false);
  }


   const handleChange = (key, value,item) => {
    setStateValue((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    if(item==="role"){
      // setAuth((prev)=>({...prev,userrole:value}))
      localStorage.setItem("userrole",value)
      switchRole(value)

    }
  };


  if (
    localStorage.access_token &&
    localStorage.roles &&
    localStorage.userrole
  ) {
    var roles = [{ value: localStorage.userrole, label: "Select Role" }];
    var role = localStorage.roles.split(",");
    for (let i = 0; i < role.length; i++) {
      if (
        !(
          role[i].includes("default") ||
          role[i].includes("offline") ||
          role[i].includes("admn") ||
          role[i].includes("authorization")
        )
      )
        roles.push({ value: role[i], label: role[i] });
    }
  }

  const handleShow = () => {
    setShow(true);
  };

  const logout = () => {
    // localStorage.clear();
    navigate("/");
    // window.location.replace("https://demoecinet.eci.gov.in/logout");
    // window.location.href = "/";
    
  };

  const logoutConfirm = () => {
    handleShow();
  };

  const logMeoutConfirm = () => {
    setCookie("XUSRLGLK",'true')
    setShow(false);
    logoutApi(
      {
        userName : parseJwt(localStorage.getItem("access_token")).preferred_username, 
        id : parseJwt(localStorage.getItem("access_token")).session_state
      }
    ).then((res)=>{
    //  logoutAuthContext()
    localStorage.clear()
      navigate('/login')
    }).catch((err)=>{
    //  logoutAuthContext()
    localStorage.clear()
      navigate('/login')
    })
  };


   function switchRole(value) {
    if (value != undefined) {
      // localStorage.userrole = stateValue.role;
      
       if(['ro','roac','ropc','deo','ceo','ceoa','nodal','record','unit','cs','epbr','epba','eci'].includes(value.toLowerCase())){
      
                navigate("/" + value + "/" + "dashboard");
             
                 }else{
                  navigate("/" + value + "/" + "accessNotAllowed");
                 }
    }
  }
  
  let zoomLevel = 1;
  const zoomInFun = () => {
    if (zoomLevel < 1.1) {
      zoomLevel = zoomLevel + 0.05;
      document.getElementById("root").style.zoom = `${zoomLevel}`;
    }
  };
  const zoomOutFun = () => {
    if (zoomLevel > 0.9) {
      zoomLevel = zoomLevel - 0.05;
      document.getElementById("root").style.zoom = `${zoomLevel}`;
    }
  };
  const zoomNormalFun = () => {
    zoomLevel = 1;
    document.getElementById("root").style.zoom = `${zoomLevel}`;
  };
  const wideFunc = (ind) => {
    if (ind === 0) {
      document.getElementById("root").style.wordSpacing = "normal";
    }
    if (ind === 1) {
      document.getElementById("root").style.wordSpacing = "5px";
    }
    if (ind === 2) {
      document.getElementById("root").style.wordSpacing = "10px";
    }
  };

  // const path = "/" + localStorage.userrole
  console.log(stateValue)

  return (
    <>
      <header className="eci-header">
      <Container fluid className=" border-bottom">
        {/* Desktop View */}
        <Row className="align-items-center d-none d-md-flex justify-content-end px-3 py-1" style={{background:"#5342BF" ,color:"#ffff"}}>
            <HouseDoor
            size={15}
            />
            
            {/* <Typography >|</Typography> */}
 <span className="ml-2">|</span>
            <Button variant="" className="icon-btn ml-2"  onClick={() => wideFunc(0)} aria-label="Change Word Spacing Normal" >
              AB
            </Button>
            <Button variant="" className="icon-btn"  onClick={() => wideFunc(1)} aria-label="Change Word Spacing Wide">
              A_B
            </Button>
            <Button variant="" className="icon-btn"  onClick={() => wideFunc(2)} aria-label="Change Word Spacing Too Wide">
              A__B
            </Button>
            <span >|</span>

            <Button variant="" className="icon-btn ml-2"  onClick={zoomOutFun} aria-label="Change Font Size to Small">
              A-
            </Button>
            <Button variant="" className="icon-btn"  onClick={zoomNormalFun} aria-label="Change Font Size to Normal">
              A
            </Button>
            <Button variant="" className="icon-btn"  onClick={zoomInFun} aria-label="Change Font Size to Large">
              A+
            </Button>

        </Row>
        <Row className="align-items-center d-none d-md-flex">
          {/* Left */}
             <Col md={"auto"} className="d-flex  align-items-center">
            <Image src="/ECINet-logo.png" alt="ECINet Logo" height="55" width={55} className="me-2" />
            <div className="eci-ecinet-text">ECINet</div>
          </Col>
         
                &nbsp;&nbsp;&nbsp;&nbsp;<Divider orientation="vertical" variant="middle" flexItem />&nbsp;
          {/* Center */}
        <Col  className="d-flex align-items-center" style={{margin:"4px 0px 4px 0px"}}>
            <Image src={logo} alt="ECI Logo" height="55" width={55} className="me-2" />
            <div>
              <div className="eci-english">ETPBMS</div>
            </div>
          </Col>
 
          {/* Right */}
       {userData &&   <Col md="auto" className="d-flex align-items-center justify-content-end">
        {roles?.length>2 && <SelectField
                              name="role"
                              options={roles}
                              inputClass="col-auto"
                              labelClass="col-auto"
                              value={stateValue.role}
                              handleChange={(val) => handleChange("role", val,"role")}
                              // onInput={()=>{switchRole()}}
                            />
}
            <div className="text-end me-2" style={{margin:"14px 0px 14px 14px" }}>
              <div className="eci-admin">{`${user} (${localStorage?.getItem("userrole")})`}</div>
              <div className="eci-dept d-flex">{stateValue.asmblyName && userData?.authorizedAcs &&
                      (<div size="auto" ><p className="mb-0">AC: {userData?.authorizedAcs?.[0]} - {stateValue.asmblyName}&nbsp;/&nbsp;</p></div>)}
                    {stateValue.districtName &&
                      (<div size="auto" ><p className="mb-0">Dist: {stateValue.districtName}&nbsp;/&nbsp;</p></div>)}
                    {stateValue.stateName &&
                      (<div size="auto" ><p className="mb-0">State: {stateValue.stateName} </p></div>)}
</div>
            </div>
               &nbsp;&nbsp;&nbsp;&nbsp;<Divider orientation="vertical" variant="middle" flexItem />&nbsp;&nbsp;
            <div className="avatar-circle me-2 m-1">{stateValue?.file ? <img style={{    height: "50px",
    width: "50px",
    borderRadius: "50%"}} src={`data:image/jpg;base64,${stateValue.photoUrl ? stateValue?.file : ""
            }`} alt="P" /> : "P"}</div>
            <Button variant="link" onClick={logoutConfirm} className="p-0 text-danger logout-btn m-1">
              <Power size={25} strokeWidth={2.5} />
            </Button>
          </Col>}
        </Row>
 
        {/* Mobile View */}
          <Row className="d-md-none justify-content-end px-3 py-1" style={{background:"#5342BF" ,color:"#ffff"}}>
            <p className="m-0"><HouseDoor
            size={15}
            /></p>
            
            {/* <Typography >|</Typography> */}
 <span className="ml-2">|</span>
            <Button variant="" className="icon-btn ml-2" style={{fontSize:"13px",padding: "0px 12px 0px 12px"}}  onClick={() => wideFunc(0)} aria-label="Change Word Spacing Normal" >
              AB
            </Button>
            <Button variant="" className="icon-btn" style={{fontSize:"13px",padding: "0px 12px 0px 12px"}}  onClick={() => wideFunc(1)} aria-label="Change Word Spacing Wide">
              A_B
            </Button>
            <Button variant="" className="icon-btn" style={{fontSize:"13px",padding: "0px 12px 0px 12px"}}  onClick={() => wideFunc(2)} aria-label="Change Word Spacing Too Wide">
              A__B
            </Button>
            <span >|</span>

            <Button variant="" className="icon-btn ml-2" style={{fontSize:"13px",padding: "0px 12px 0px 12px"}}  onClick={zoomOutFun} aria-label="Change Font Size to Small">
              A-
            </Button>
            <Button variant="" className="icon-btn"  style={{fontSize:"13px",padding: "0px 12px 0px 12px"}} onClick={zoomNormalFun} aria-label="Change Font Size to Normal">
              A
            </Button>
            <Button variant="" className="icon-btn"  style={{fontSize:"13px",padding: "0px 12px 0px 12px"}} onClick={zoomInFun} aria-label="Change Font Size to Large">
              A+
            </Button>

        </Row>
        <Row className="d-md-none text-center">
          {/* Row 1 - ECINet */}
          <Col xs={4} className="d-flex justify-content-center align-items-center mb-1">
            <Image src="/ECINet-logo.png" alt="ECINet Logo" height="35" className="me-2" />
            <div className="eci-ecinet-text">ECINet</div>
          </Col>
            <Col xs={8}  className="d-flex flex-row align-items-center mb-1 " style={{justifyContent:"center"}}>
            <div>
               <Image src={logo} alt="ECI Logo" height="45" className="" />
            </div>
            <div className="mt-auto mb-auto ml-2" >
            <div className="eci-english">ETPBMS</div>
            </div>
          </Col>
          
 
          {/* Row 2 - ECI Logo + Title */}
        
 
          {/* Row 3 - Admin Info */}
       {userData &&   <Col xs={12} className="d-flex justify-content-end align-items-center">
            <div className="text-center me-2">
              <div className="eci-admin">{`${user} - ${localStorage?.getItem("userrole")}`}</div>
              <div className="eci-dept d-flex">
 {stateValue.asmblyName && userData?.authorizedAcs &&
                      (<div size="auto" ><p>AC: {userData?.authorizedAcs?.[0]} - {stateValue.asmblyName}&nbsp;/&nbsp;</p></div>)}
                    {stateValue.districtName &&
                      (<div size="auto" ><p>Dist: {stateValue.districtName}&nbsp;/&nbsp;</p></div>)}
                    {stateValue.stateName &&
                      (<div size="auto" ><p>State: {stateValue.stateName} </p></div>)}

              </div>
            </div>
 <div className="avatar-circle me-2 m-1">{stateValue?.file ? <img style={{    height: "50px",
    width: "50px",
    borderRadius: "50%"}} src={`data:image/jpg;base64,${stateValue.photoUrl ? stateValue?.file : ""
            }`} alt="P" /> : "P"}</div>
            <Button variant="link" onClick={logoutConfirm} className="p-0 text-danger logout-btn">
              <Power size={18} />
            </Button>
          </Col>}
        </Row>
          <ActionModal
                    show={show}
                    actionButton="none"
                    sessionButton="block"
                    onHide={handleClose}
                    logmeOut={logMeoutConfirm}
                    onClick={handleClose}
                    modalBody="Are you sure you want to logout?"
                    modalHeading=""
                  />
      </Container>
    </header>
  
    </>

  );
}

export default Navigation;
